import { useContext } from "react";

import { type Coachmark, type DispatchCoachmarks, DispatchContext, type State, StateContext } from "./reducer";

export function useCoachmarksState(): State {
    const context = useContext(StateContext);

    if (context === undefined) {
        throw new Error("useCoachmarksState must be used within a CoachmarksProvider");
    }

    return context;
}

export function useDispatchCoachmarks(): DispatchCoachmarks {
    const context = useContext(DispatchContext);

    if (context === undefined) {
        throw new Error("useDispatchCoachmarks must be used within a CoachmarksProvider");
    }

    return context;
}

export function useActiveCoachmark(): Coachmark | undefined {
    const state = useCoachmarksState();
    return state.coachmarks.at(-1);
}
